import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonNBProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  children: ReactNode;
}

const sizeStyles = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-3 text-base',
  lg: 'px-6 py-4 text-lg',
};

const variantStyles = {
  primary: 'bg-nb-black text-white border-3 border-nb-black hover:border-4',
  secondary: 'bg-nb-white text-nb-black border-3 border-nb-black hover:border-4',
  danger: 'bg-nb-red text-white border-3 border-nb-black hover:border-4',
};

export default function ButtonNB({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  children,
  className = '',
  ...props
}: ButtonNBProps) {
  const baseStyles = `
    inline-flex items-center justify-center gap-2
    font-nb font-bold
    border-solid border-0
    rounded-[2px]
    transition-transform duration-200 ease-out
    cursor-pointer
    disabled:opacity-50 disabled:cursor-not-allowed
  `.replace(/\s+/g, ' ').trim();

  const variantClass = variantStyles[variant] || variantStyles.primary;
  const sizeClass = sizeStyles[size] || sizeStyles.md;

  return (
    <button
      className={`${baseStyles} ${variantClass} ${sizeClass} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="inline-block w-5 h-5 border-3 border-current border-t-transparent animate-spin" />
      ) : (
        children
      )}
    </button>
  );
}